import {
  SET_DEFICIENCY_TYPES
} from './mutationTypes'

export const mutations = {
  [SET_DEFICIENCY_TYPES]: (state, payload) => state.deficiencyTypes = payload
}
